// extracted by mini-css-extract-plugin
export default {"trailer-container":"MovieTrailer_trailer-container__H8yAw","title":"MovieTrailer_title__VNnv2","back":"MovieTrailer_back__Im8tg"};